
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/news",
      function () {
        return require("private-next-pages/en/news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/news"])
      });
    }
  